import { Component } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Company } from "src/app/models/company.model"
import { ToastService } from "src/app/services/toast/toast.service"
import { GroupService } from "src/app/services/group/group.service"
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service"
import { Roles } from "src/app/auth/roles";

@Component({
  standalone: false,
  selector: 'app-add-temp-group',
  templateUrl: './add-temp-group.component.html',
  styleUrls: ['./add-temp-group.component.css']
})
export class AddTempGroupComponent {
	readonly Roles = Roles;
  selectedValues = {
    company: {
      companyId: 0,
      companyName: "",
    },
    plant: {
      plantId: 0,
      plantName: "",
    },
    groupType: {
      id: 2,
      type: "Temporary User Groups"
    }
  }

  addTempGroupRequest = {
    tempGroupId: 0,
    groupName: "",
    isDeleted: false,
    status: "active",
  }

  errorMessage: any = {
    success: true,
    message: "",
  }

  companies: Company[] = []
  plants: any
  retrievedCompany: any
  currentRole: any = ""

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public toastService: ToastService,
    private groupService: GroupService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.selectedValues.company = history.state.company
    this.selectedValues.plant = history.state.plant
    this.currentRole = localStorage.getItem("role")
  }

  activateSubmitBtn() {
    if (this.addTempGroupRequest.groupName.length < 3) {
      return false
    }
    return true
  }

  // firstRender = true

  transferData() {
    // this.firstRender = true
    this.router.navigateByUrl("settings/groups", {
      state: {
        selectedValues: { ...this.selectedValues },
        firstRender: true,
      },
    })
  }

  addNonAdminGroup() {
    const item = {
      groupName: this.addTempGroupRequest?.groupName,
      plantId: this.selectedValues?.plant?.plantId
    }

    this.groupService.addTempGroup(item)
      .subscribe({
        next: (response) => {
          this.router.navigate(['settings/groups'], { state: { selectedValues: { ...this.selectedValues }, firstRender: true, prevPage: "Add_Temp_Group", success: true } });
          this.toastService.showToast = true;
          this.toastService.toastText = `Temporary User Group: ${this.addTempGroupRequest.groupName} added successfully`;

          // Navigate back to the previous page
          setTimeout(() => {
            this.toastService.showToast = false;
          }, 3000);
        },
        error: (error) => {
          this.errorService.handleError(error, 'Error adding temporary group')
        },
      })

  }
}

